/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Map_TitleInputs */

const en_us2_progress_extra_map_title = /** @type {(inputs: Progress_Extra_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week's muscles`)
};

const pt_br2_progress_extra_map_title = /** @type {(inputs: Progress_Extra_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos da semana`)
};

const es_419_progress_extra_map_title = /** @type {(inputs: Progress_Extra_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos de la semana`)
};

const pt_pt2_progress_extra_map_title = /** @type {(inputs: Progress_Extra_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos da semana`)
};

const fr_fr2_progress_extra_map_title = /** @type {(inputs: Progress_Extra_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscles de la semaine`)
};

const de_de2_progress_extra_map_title = /** @type {(inputs: Progress_Extra_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskeln dieser Woche`)
};

const it_it2_progress_extra_map_title = /** @type {(inputs: Progress_Extra_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscoli della settimana`)
};

/**
* | output |
* | --- |
* | "This week's muscles" |
*
* @param {Progress_Extra_Map_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_title = /** @type {((inputs?: Progress_Extra_Map_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_title(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_title(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_title(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_title(inputs)
	return en_us2_progress_extra_map_title(inputs)
});
export { progress_extra_map_title as "progress-extra.map_title" }